import { getInterpolation, mergeTranslations } from "./utils.js";
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
var _translations = /*#__PURE__*/ new WeakMap(), _language = /*#__PURE__*/ new WeakMap(), _namespace = /*#__PURE__*/ new WeakMap(), _fallbackLanguages = /*#__PURE__*/ new WeakMap(), _fallbackNamespaces = /*#__PURE__*/ new WeakMap(), _insertedBundles = /*#__PURE__*/ new WeakMap(), _getNamespaces = /*#__PURE__*/ new WeakSet(), _getLocales = /*#__PURE__*/ new WeakSet();
class CrehanaI18n {
    setLanguage(language) {
        _class_private_field_set(this, _language, language);
    }
    setNamespace(namespace) {
        _class_private_field_set(this, _namespace, namespace);
    }
    setFallbackLanguages(languages) {
        _class_private_field_set(this, _fallbackLanguages, languages);
    }
    setFallbackNamespaces(namespaces) {
        _class_private_field_set(this, _fallbackNamespaces, namespaces);
    }
    t(key, config) {
        const { defaultValue, interpolation, namespace } = config || {};
        const locales = _class_private_method_get(this, _getLocales, getLocales).call(this, namespace);
        const count = 'number' == typeof interpolation?.count ? interpolation.count : config?.count;
        if (locales) {
            let replacements;
            let foundLocale = locales[key];
            if (count) {
                replacements = {
                    count
                };
                if (count > 1) {
                    const pluralKey = `${key}_plural`;
                    if (locales[pluralKey]) foundLocale = locales[pluralKey];
                }
            }
            const locale = foundLocale || defaultValue;
            if ((replacements || interpolation) && locale) return getInterpolation(locale, {
                ...replacements,
                ...interpolation
            });
            return locale || key;
        }
        return defaultValue || key;
    }
    addResourceBundle(bundle) {
        if (_class_private_field_get(this, _insertedBundles).has(bundle)) return false;
        _class_private_field_get(this, _insertedBundles).add(bundle);
        _class_private_field_set(this, _translations, mergeTranslations(_class_private_field_get(this, _translations), bundle));
        return true;
    }
    constructor(params){
        _class_private_method_init(this, _getNamespaces);
        _class_private_method_init(this, _getLocales);
        _class_private_field_init(this, _translations, {
            writable: true,
            value: {}
        });
        _class_private_field_init(this, _language, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _namespace, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _fallbackLanguages, {
            writable: true,
            value: []
        });
        _class_private_field_init(this, _fallbackNamespaces, {
            writable: true,
            value: []
        });
        _class_private_field_init(this, _insertedBundles, {
            writable: true,
            value: new WeakSet()
        });
        _class_private_field_set(this, _language, params.language);
        _class_private_field_set(this, _namespace, params.namespace);
        if (params.translations) _class_private_field_set(this, _translations, params.translations);
    }
}
function getNamespaces() {
    const foundNamespace = _class_private_field_get(this, _translations)[_class_private_field_get(this, _language)];
    if (foundNamespace) return foundNamespace;
    if (_class_private_field_get(this, _fallbackLanguages)) for(let i = 0; i < _class_private_field_get(this, _fallbackLanguages).length; i++){
        const language = _class_private_field_get(this, _fallbackLanguages)[i];
        if (language) {
            const foundFallbackNamespace = _class_private_field_get(this, _translations)[language];
            if (foundFallbackNamespace) return foundFallbackNamespace;
        }
    }
}
function getLocales(customNamespace) {
    const namespaces = _class_private_method_get(this, _getNamespaces, getNamespaces).call(this);
    if (!namespaces) return;
    const ns = customNamespace || _class_private_field_get(this, _namespace);
    if (ns) {
        const foundLocales = namespaces[ns];
        if (foundLocales) return foundLocales;
    }
    if (_class_private_field_get(this, _fallbackNamespaces)) for(let i = 0; i < _class_private_field_get(this, _fallbackNamespaces).length; i++){
        const namespace = _class_private_field_get(this, _fallbackNamespaces)[i];
        if (namespace) {
            const foundFallbackLocales = namespaces[namespace];
            if (foundFallbackLocales) return foundFallbackLocales;
        }
    }
}
const i18n = CrehanaI18n;
export default i18n;
export { CrehanaI18n };
